export interface NavigationOptions {
    container: HTMLDivElement;
    visible?: boolean;
}

export class Navigation {

    private _element: HTMLDivElement;
    private _options: NavigationOptions;
    private _buttons: NavigationButton[] = [];

    constructor(options: NavigationOptions) {

        options = e5.object.merge({
            container: null,
            visible: true
        } as NavigationOptions, options);
        this._options = options;

        this._element = document.createElement("div");
        this._element.className = "navigation base--hide-top";

        if (options.visible === false) {
            this.visible = false;
        }

        if (options.container) {
            options.container.appendChild(this._element);
        }
    }

    public addButton(options: NavigationButtonOptions): NavigationButton {
        const btn = new NavigationButton(options, this);
        this._element.appendChild(btn.element);
        return btn;
    }

    public get visible(): boolean {
        return !this._element.classList.contains("base--hidden");
    }

    public set visible(value: boolean) {
        this._element.classList.toggle("base--hidden", !value);
    }
}

export interface NavigationButtonOptions {
    icon: string;
    title: string;
    onClick?: (btn: NavigationButton) => void;
    visible?: boolean;
}

export class NavigationButton {

    public readonly onClick = e5.Signal.create<[NavigationButton]>();
    public readonly element: HTMLButtonElement;
    public readonly options: NavigationButtonOptions;

    constructor(options: NavigationButtonOptions,
        private _navigation: Navigation) {

        options = e5.object.merge({
            visible: true
        }, options);

        this.options = options;
        this.element = document.createElement("button");
        this.element.className = "navigation__button";

        const icon = document.createElement("span");
        icon.className = "navigation__icon " + options.icon;
        this.element.appendChild(icon);

        this.visible = options.visible;

        this.element.addEventListener("click", () => {
            if (this._navigation.visible
                && this.visible) {
                this.onClick.dispatch(this);
            }
        });
        if (typeof options.onClick === "function") {
            this.onClick.add(options.onClick);
        }
    }

    public get visible(): boolean {
        return !this.element.classList.contains("navigation__button--hidden");
    }

    public set visible(value: boolean) {
        this.element.classList.toggle("navigation__button--hidden", !value);
    }
}